/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Endpoint { 
    id: string;
    label: string;
    type: Endpoint.TypeEnum;
    url: string;
}
export namespace Endpoint {
    export type TypeEnum = 'COUPONCODE' | 'COMMUNICATION';
    export const TypeEnum = {
        COUPONCODE: 'COUPONCODE' as TypeEnum,
        COMMUNICATION: 'COMMUNICATION' as TypeEnum
    };
}


